export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Settings.json?hash=8ca600f38ab380872f7a2732d3d1783a";